export default "__VITE_ASSET__BIgSwyMw__"